import { NativeError, ProjectAsset, RuntimeError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { getAssetUrl } from 'src/modules/common/sagas/utils/getAssetUrl';
import {
  ReportAttachment,
  ReportAttachmentDocument,
  ReportAttachmentImage,
} from 'src/modules/report/types/ReportAttachment';
import { getPdfMetadata } from 'src/modules/worker/sagas/utils/getPdfMetadata';
import { call } from 'typed-redux-saga';

export function* prepareReportAttachment(file: ProjectAsset): SagaIterator<ReportAttachment> {
  try {
    if (file.mimeType === 'application/pdf') {
      return {
        id: file.id,
        state: 'success',

        type: 'document',
        file: file,
        meta: yield* call(getPdfMetadata, file),
        url: yield* call(getAssetUrl, file.id),
      } satisfies ReportAttachmentDocument;
    }

    return {
      id: file.id,
      state: 'success',

      type: 'image',
      file: file,
      url: yield* call(getAssetUrl, file.id),
    } satisfies ReportAttachmentImage;
  } catch (error) {
    throw new RuntimeError('Could not prepare report attachment', { file }, NativeError.wrap(error));
  }
}
